const navigationLabels = {
  recordMgmt: "Record Mgmt",
  startInterview: "Start Interview",
  demographics: "Demographics",
  substanceUse1: "Substance Use 1",
  substanceUse2: "Substance Use 2",
  substanceUse3: "Substance Use 3",
  plannedServices1: "Planned Services 1",
  plannedServices2: "Planned Services 2",
  plannedServices3: "Planned Services 3",
  plannedServices4: "Planned Services 4",
  living: "Family",
  education: "Education",
  legal: "Legal",
  mental: "Mental",
  social: "Social Connectedness",
  program: "Program Questions",
  followUp: "Follow Up",
  discharge: "Discharge",
  servicesReceived1: "Services Received 1",
  servicesReceived2: "Services Received 2",
  servicesReceived3: "Services Received 3",
  servicesReceived4: "Services Received 4",
  servicesReceived5: "Services Received 5",
  summary: "Summary",
}

export default navigationLabels
